import PropTypes from 'prop-types';
import { STRIPE_AD_BLOCKER_ERROR, STRIPE_CONNECTION_ERROR } from '../../utils/constants';

/** @type {string} */
const SUPPORT_MESSAGE = 'If the problem persists, contact support@ghost.org.';

/** @type {string} */
const AD_BLOCKER_TITLE = 'Ad blocker detected';

/** @type {string} */
const CONNECTION_ERROR_TITLE = 'Connection error';

/**
 * Error state component for Stripe card update failures
 * @param {object} props - Component props
 * @param {object} props.stripeError - Error object from Stripe loading failure
 * @param {boolean} props.stripeError.isAdBlocker - Whether the error is caused by ad blocker
 * @param {Function} props.onRetry - Callback function to retry the operation
 * @returns {JSX.Element} React component displaying error state with retry option
 */
export default function UpdateCardErrorState({ stripeError, onRetry = () => {} }) {
    if (!stripeError) {
        return null;
    }

    const isAdBlockerError = Boolean(stripeError.isAdBlocker);

    return (
        <>
            <h1 className="modal-title adblocker-title">
                {isAdBlockerError ? AD_BLOCKER_TITLE : CONNECTION_ERROR_TITLE}
            </h1>
            <div className="adblocker-warning">
                {isAdBlockerError ? (
                    <>
                        <p>{STRIPE_AD_BLOCKER_ERROR}</p>
                        <p>{SUPPORT_MESSAGE}</p>
                    </>
                ) : (
                    <>
                        <p>{STRIPE_CONNECTION_ERROR}</p>
                        <p>{SUPPORT_MESSAGE}</p>
                    </>
                )}
            </div>
            <button className="gh-btn gh-btn-black gh-btn-block" onClick={onRetry}>
                Try again
            </button>
        </>
    );
}

UpdateCardErrorState.propTypes = {
    stripeError: PropTypes.shape({
        isAdBlocker: PropTypes.bool,
    }),
    onRetry: PropTypes.func,
};
